var map = {
	"./address_image.svg": 129,
	"./animated_logo.svg": 130,
	"./blogs_image.svg": 131,
	"./chewy_logo.png": 132,
	"./chewy_small_logo.png": 133,
	"./chewy_small_logo_1.png": 134,
	"./cloud_infrastructure.svg": 135,
	"./codeInLogo.png": 136,
	"./contactMail.png": 137,
	"./coursera_logo.png": 138,
	"./data_science.svg": 139,
	"./deeplearning_ai_logo.png": 140,
	"./delhivery_logo.png": 141,
	"./developerActivity.svg": 142,
	"./dsc_logo.png": 143,
	"./education.svg": 144,
	"./elsevier_logo.png": 145,
	"./experience.svg": 146,
	"./feelingProud.svg": 147,
	"./freecopy_logo.png": 148,
	"./fullstack.svg": 149,
	"./gcp_logo.png": 150,
	"./github_logo.png": 151,
	"./googleAssistant.jpg": 152,
	"./googleAssistant.svg": 153,
	"./google_logo.png": 154,
	"./gsu_logo.png": 155,
	"./gsu_small_logo.png": 156,
	"./ibm_logo.png": 157,
	"./iiitk_logo.png": 158,
	"./intel_logo.jpg": 159,
	"./iu_logo.png": 160,
	"./jsFramework.svg": 161,
	"./legato_logo.png": 162,
	"./manOnTable.svg": 163,
	"./microsoft_logo.png": 164,
	"./mozilla_logo.png": 165,
	"./muffito_logo.png": 166,
	"./nextuLogo.jpg": 167,
	"./nptel_logo.png": 168,
	"./nss_logo.png": 169,
	"./portfolio.gif": 170,
	"./programmer.svg": 171,
	"./projects_image.svg": 172,
	"./pwa.png": 173,
	"./python_logo.png": 174,
	"./qeios_logo.png": 175,
	"./saayaHealthLogo.png": 176,
	"./springer_logo.png": 177,
	"./springer_small_logo.png": 178,
	"./stanford_logo.png": 179,
	"./talksCardBack.svg": 180,
	"./talksCardBackAlt.svg": 181,
	"./tcs_logo.png": 182,
	"./tcs_small_logo.png": 183,
	"./tcs_small_logo1.png": 184,
	"./teja.png": 185,
	"./tiktok_logo.png": 186,
	"./trends_logo.png": 187,
	"./trends_small_logo.png": 188,
	"./ui_ux_design.svg": 189,
	"./unknown_logo.png": 190,
	"./vignan_logo.png": 191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;